import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LangSwitcher.module.css';

const LANGS = [
  { code: 'pt', label: 'PT' },
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
];

function LangSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGS.find((l) => l.code === i18n.language) ?? LANGS[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        className={`${styles.trigger} ${open ? styles.open : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <svg className={styles.icon} width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 12h20M12 2c2.5 2.5 4 6.5 4 10s-1.5 7.5-4 10M12 2C9.5 4.5 8 8.5 8 12s1.5 7.5 4 10" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
        <span className={styles.currentLang}>{current.label}</span>
      </button>

      <div className={`${styles.dropdown} ${open ? styles.dropdownOpen : ''}`}>
        {LANGS.map((l) => (
          <button
            key={l.code}
            className={`${styles.option} ${l.code === current.code ? styles.active : ''}`}
            onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
          >
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default LangSwitcher;